import { MdInfo } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const AboutSettings = () => {
  const navigate = useNavigate();

  const appFeatures = [
    "Secure user authentication with personal profiles",
    "Create posts, react to content, and engage in discussions",
    "Real-time messaging with instant delivery",
    "Smart user and content discovery",
    "Fully responsive across mobile and desktop devices",
    "Customizable profiles and preferences",
    "JWT-based secure authentication system",
    "Open-source, scalable, and continuously evolving",
  ];

  return (
    <div className="max-w-7xl mx-auto px-6 py-10">
      
      {/* Header */}
      <div className="flex items-center gap-3 mb-8">
        <div className="p-2 rounded-xl bg-violet-100 text-violet-600">
          <MdInfo size={24} />
        </div>
        <h1 className="text-3xl font-semibold text-gray-900">
          About Flowline Messenger
        </h1>
      </div>

      {/* Back */}
      <button
        onClick={() => navigate("/")}
        className="mb-8 text-sm font-medium text-violet-600 hover:underline"
      >
        ← Back to app
      </button>

      {/* Content Card */}
      <div className="bg-white rounded-2xl border shadow-sm p-8 space-y-8">
        
        {/* Overview */}
        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">
          🫟 What is Flowline Messenger?
          </h2>
          <p className="text-gray-600 leading-relaxed">
            Flowline Messenger is a modern social and real-time communication
            platform designed for meaningful conversations and thoughtful
            expression. It combines the simplicity of messaging with the power
            of social interaction — enabling users to connect, share ideas,
            and communicate seamlessly in one unified space.
          </p>
        </section>

        {/* Features */}
        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-4">
            Core Features
          </h2>
          <ul className="grid sm:grid-cols-2 gap-3 text-sm text-gray-600">
            {appFeatures.map((feature, idx) => (
              <li key={idx} className="flex items-start gap-2">
                <span className="mt-1 w-2 h-2 rounded-full bg-violet-500" />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* Vision */}
        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">
            Vision
          </h2>
          <p className="text-gray-600 leading-relaxed">
            Flowline Messenger is built with a focus on clarity, privacy, and
            human-centered communication. The goal is to move beyond noisy
            social platforms and provide a calm, intentional space where
            conversations flow naturally and ideas matter.
          </p>
        </section>

        {/* Version */}
        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">
            Open Source & Development
          </h2>
          <p className="text-gray-600">
            Flowline Messenger is an open-source project, actively developed and
            improved. Contributions, feedback, and ideas are always welcome.
          </p>

          <a
            href="https://github.com/vikaschamyal"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-3 text-sm font-medium text-violet-600 hover:underline"
          >
            Explore the GitHub repository →
          </a>
        </section>
      </div>
    </div>
  );
};

export default AboutSettings;
